'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useFavoriteGames } from '@/hooks/use-favorite-games';
import {
    getPostLoginAction,
    clearPostLoginAction,
    openDepositSafely,
    POST_LOGIN_ACTION_TYPE,
    type PostLoginAction
} from '@/utils/post-login-action/post-login-action';
import { useGlobalContext } from '@/store/contexts/global-context';
import { useWalletUm } from '@/hooks/use-wallet-um';
import { useStore } from '@/store/store';
import { launchGameWindow } from '@/utils/promotion-game-launch/promotion-game-launch';
import { useLauncherUrlResolution } from '@/hooks/use-launcher-url-resolution';

export const usePostLoginActionHandler = () => {
    const router = useRouter();
    const { addFavoriteGame } = useFavoriteGames();
    const { isMobile, isXsellWrapper, isAndroidWrapper, region } = useGlobalContext();
    const launcherResolution = useLauncherUrlResolution();
    const { triggerDeposit } = useWalletUm();
    const isLoggedIn = useStore((s) => s.userContext.isLoggedIn);
    const addGameWindow = useStore((s) => s.addGameWindow);

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }
        const action: PostLoginAction | null = getPostLoginAction();
        if (!action) {
            return;
        }
        clearPostLoginAction();

        const consume = async () => {
            switch (action.type) {
                case POST_LOGIN_ACTION_TYPE.OPEN_DEPOSIT:
                    await openDepositSafely(triggerDeposit);
                    return;
                case POST_LOGIN_ACTION_TYPE.ADD_FAVORITE:
                    await addFavoriteGame(action.uid);
                    break;
                case POST_LOGIN_ACTION_TYPE.LAUNCH_GAME:
                    launchGameWindow(action.url, {
                        isMobile,
                        isXsellWrapper,
                        isAndroidWrapper,
                        addGameWindow,
                        region,
                        launcherResolution
                    });
                    break;
            }
            router.refresh();
        };
        consume();
    }, [
        isLoggedIn,
        addFavoriteGame,
        addGameWindow,
        isMobile,
        isXsellWrapper,
        isAndroidWrapper,
        region,
        launcherResolution,
        router,
        triggerDeposit
    ]);
};
